import { encryptKey } from "../utils/encryption";
import apiClient from "../utils/appClient";
import { jwtDecode } from "jwt-decode";
import { Device } from "@schemas";

export const getToken = async () => {
  try {
    const encryptedKey = encryptKey("123yesitissecertlol");
    // console.log(encryptedKey);
    const response = await apiClient.post("/api/auth/token", {
      encryptedKey: encryptedKey,
    });

    const token = response.data?.token;
    if (token) {
      localStorage.setItem("authToken", token);
    }

    return token;
  } catch (error) {
    console.error("Token fetch error:", error);
    return null;
  }
};
export interface DeviceHealth {
  device_id: string;
  last_heart_beat_time: string | Date | null;
  last_cbom_sync_time: string | Date | null;
  no_of_cbom_records: number;
  no_of_va_records?: number | null;
  cbom_status: "first" | "intermediate" | "incremental" | "complete";
  va_status?: string | null;
  ip_address?: string;
  status?: "active" | "deactive";
}
export const fetchDeviceHealth = async (
  projectId: string
): Promise<DeviceHealth[]> => {
  const token = localStorage.getItem("token");
  const response = await apiClient.get<{ data: DeviceHealth[] }>(
    `api/device-health?table_name=${projectId}_device_health`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  return response.data.data;
};
export const fetchDeviceMeta = async (
  projectId: string
): Promise<
  Record<string, { ip_address: string; status: "active" | "inactive" }>
> => {
  const token = localStorage.getItem("token");
  const response = await apiClient.get<any[]>(
    `api/devices/get-device/${projectId}_device`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  const metaMap: Record<
    string,
    { ip_address: string; status: "active" | "inactive" }
  > = {};
  response.data.forEach((item: any) => {
    metaMap[item.device_id] = {
      ip_address: item.ip_address,
      status: item.status,
    };
  });
  return metaMap;
};
export const fetchKeys = async (
  setKeysData: (data: any) => void,
  selectedDeviceId: string,
  showCbomComponent: boolean,
  projectId: string
) => {
  try {
    const token = localStorage.getItem("token");
    const apiUrl = showCbomComponent
      ? `api/keys/${selectedDeviceId}?table_name=${projectId}_cbom_keys`
      : `api/keys?table_name=${projectId}_cbom_keys`;
    const response = await apiClient.get<{ data: any }>(`${apiUrl}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    setKeysData(response.data.data);
    // console.log(response.data.data);
  } catch (err: any) {
    console.log(err.message || "Failed to fetch device health data.");
  }
};

export const fetchCertificates = async (
  setKeysData: (data: any) => void,
  selectedDeviceId: string,
  showCbomComponent: boolean,
  projectId: string
) => {
  try {
    const token = localStorage.getItem("token");
    const apiUrl = showCbomComponent
      ? `api/certificates/${selectedDeviceId}?table_name=${projectId}_cbom_certificates`
      : `api/certificates?table_name=${projectId}_cbom_certificates`;
    const response = await apiClient.get<{ data: any }>(`${apiUrl}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    setKeysData(response.data.data);
    // console.log(response.data.data);
  } catch (err: any) {
    console.log(err.message || "Failed to fetch device health data.");
  }
};
export const fetchSensorAgent = async (
  setAgentData: (data: any) => void,
  projectId: string
) => {
  try {
    const token = localStorage.getItem("token");
    const response = await apiClient.get<{ data: any }>(
      `/api/agent-sensor?table_name=${projectId}_sensor_agent`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    setAgentData(response.data.data);
  } catch (err: any) {
    console.log(err.message || "Failed to fetch sensor agent data.");
  }
};
export const fetchSensorAgentById = async (
  selectedAgent: number,
  setFormData: (data: any) => void
) => {
  try {
    const token = localStorage.getItem("token");
    const response = await apiClient.get<{ data: any }>(
      `api/agent-sensor/:${selectedAgent}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    setFormData(response.data.data);
  } catch (err: any) {
    console.log(err.message || "Failed to fetch sensor agent data.");
  }
};
export const uploadSensorAgent = async (
  file: File,
  setIsUploaded: (value: boolean) => void
) => {
  try {
    const token = localStorage.getItem("token");
    const formData = new FormData();
    formData.append("file", file);

    const response = await apiClient.post<{ data: any }>(
      "api/agent-sensor/upload",
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      }
    );
    setIsUploaded(true);
    alert("Sensor Agent uploaded successfully");
  } catch (err: any) {
    setIsUploaded(false);
    console.log(err.message || "Failed to upload sensor agent file.");
  }
};
export const addSensorAgent = async (formData: any, projectId: string) => {
  try {
    const token = localStorage.getItem("token");

    const response = await apiClient.post<{ data: any }>(
      "api/agent-sensor/create",
      { ...formData, table_name: `${projectId}_sensor_agent` },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    alert("Sensor Agent added successfully");
    console.log(response);
  } catch (err: any) {
    console.log(err.message || "Failed to upload sensor agent file.");
  }
};

// CBOM
export const getCbomKeys = async () => {
  const token = localStorage.getItem("token");
  try {
    const response = await apiClient.get("/api/keys", {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response;
  } catch (err) {
    throw err;
  }
};

export const getCbomCertificates = async () => {
  const token = localStorage.getItem("token");
  try {
    const response = await apiClient.get("/api/certificates", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (err) {
    throw err;
  }
};

export const getCbomLibraries = async (
  setLibraryData: (data: any) => void,
  selectedDeviceId: string,
  showCbomComponent: boolean,
  projectId: string
) => {
  try {
    const token = localStorage.getItem("token");
    const apiUrl = showCbomComponent
      ? `api/libraries/${selectedDeviceId}?table_name=${projectId}_cbom_libraries`
      : `api/libraries?table_name=${projectId}_cbom_libraries`;
    console.log(apiUrl);
    const response = await apiClient.get<{ data: any }>(`${apiUrl}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    setLibraryData(response.data.data);
    // console.log(response.data.data);
  } catch (err: any) {
    console.log(err.message || "Failed to fetch device health data.");
  }
};

// History Management
export const getDeviceHealthHistory = async () => {
  try {
    const response = await apiClient.get(`/api/device-heartbeat`);
    return response;
  } catch (err) {
    throw err;
  }
};
export const getDeviceHealthHistoryById = async (deviceId: string) => {
  try {
    const response = await apiClient.get(`/api/device-heartbeat/${deviceId}`);
    return response;
  } catch (err) {
    throw err;
  }
};

export const getSensorAgentVersionHistory = async () => {
  try {
    const response = await apiClient.get(
      "/api/data/sensor-agent-version-changes"
    );
    return response;
  } catch (err) {
    throw err;
  }
};

export const getSensorAgentVersionHistoryById = async (deviceId: string) => {
  try {
    const response = await apiClient.get(
      `/api/data/sensor-agent-version-changes/${deviceId}`
    );
    return response;
  } catch (err) {
    throw err;
  }
};

export const getDeviceStatusChangeHistory = async () => {
  try {
    const response = await apiClient.get("/api/data/device-status-changes");
    return response;
  } catch (err) {
    throw err;
  }
};

export const getDeviceStatusChangeHistoryById = async (deviceId: string) => {
  try {
    const response = await apiClient.get(
      `/api/data/device-status-changes/${deviceId}`
    );
    return response;
  } catch (err) {
    throw err;
  }
};

// Sensor Agent
export const getAllSensorAgents = async (projectId: any) => {
  try {
    const response = await apiClient.get(
      `/api/agent-sensor?table_name=${projectId}_sensor_agent`
    );
    return response.data.data;
  } catch (err) {
    throw err;
  }
};

// Device Management
export const getAllDevices = async (projectId: string) => {
  try {
    const response = await apiClient.get(
      `api/devices/get-device/${projectId}_device`
    );
    return response;
  } catch (err) {
    throw err;
  }
};

export const getDeviceById = async (deviceId: string, projectId: string) => {
  try {
    // const response = await apiClient.get('/api/devices', {
    //   params: {
    //     table_name: `${projectId}_device`,
    //     id: deviceId,
    //   },
    // });
    const response = await apiClient.get(
      `/api/devices/get-device/${projectId}_device/${deviceId}`
    );
    return response;
  } catch (err) {
    throw err;
  }
};

export const updateDevice = async (
  deviceId: string,
  data: Device,
  projectId: string
) => {
  console.log(deviceId, projectId);
  console.log(data);
  try {
    const response = await apiClient.put(`/api/devices/${deviceId}`, {
      ...data,
      table_name: `${projectId}_device`,
    });
    return response;
  } catch (err) {
    throw err;
  }
};
export const getDevicesByAgentDetails = async (
  projectId: any,
  sensor_agent_version: any,
  sensor_agent_type: any
) => {
  try {
    const response = await apiClient.get(`/api/devices/by-agent-details`, {
      params: {
        sensor_agent_version,
        sensor_agent_type,
        table_name: `${projectId}_device`,
      },
    });
    return response;
  } catch (err: any) {
    throw err;
  }
};
export const addNewDevice = async (data: Device) => {
  try {
    const response = await apiClient.post(`/api/devices/`, data);
    return response;
  } catch (err) {
    throw err;
  }
};

//user management
const getEmailFromToken = (): string | null => {
  const token = localStorage.getItem("token");
  if (token) {
    try {
      const decodedToken: any = jwtDecode(token);
      return decodedToken.email;
    } catch (error) {
      // console.error("Error decoding token:", error);
      return null;
    }
  }
  return null;
};

export const getOTP = async (
  email: string,
  username: string | null = null,
  company_name: string | null = null
) => {
  try {
    const response = await apiClient.post("/api/users/register", {
      username,
      email,
      company_name,
    });
    // console.log(response);
    return response.data;
  } catch (error) {
    // console.log(error);
    // console.log(error);
    throw error;
  }
};

export const verifyOTP = async (email: string, otp: number) => {
  try {
    const response = await apiClient.post("/api/users/verify", { email, otp });
    return response.data;
  } catch (error) {
    // console.log(error);
    throw error;
  }
};

export const refreshToken = async () => {
  try {
    const token = localStorage.getItem("token");

    const response = await apiClient.post(
      "/api/users/refresh-token",
      {},
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return response.data;
  } catch (err) {
    throw err;
  }
};

export const checkAuth = async () => {
  const token = localStorage.getItem("token");
  if (!token) throw new Error("Token not found");

  try {
    const res = await apiClient.get("/api/protected-route", {
      headers: { Authorization: `Bearer ${token}` },
    });

    if (res.status === 200) {
      return res.status;
    }
  } catch (err) {
    // console.log("Token expired");
    // localStorage.removeItem("userResponses");
    localStorage.removeItem("token");
    throw new Error("Token expired");
  }
};

export const fetchUserDetails = async () => {
  try {
    const email = getEmailFromToken();
    const response = await apiClient.get(`/api/users/${email}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};
